import { dashboard } from './routes';

export const UNSUPPORTED_DOCUMENT_FALLBACK_ROUTE = dashboard.path;
